/**
 * Popup de qualification avant le tunnel "acompte seul" (bouton "Création
 * personnalisée" de la section .c-custom, home) : ce tunnel suppose que le
 * projet a déjà été discuté avec Loucas (pas de prix affiché, juste
 * l'acompte) — voir front-page.php pour le pourquoi.
 *
 * "Oui" est un lien direct (pas besoin de JS). "Non" affiche 2 nouveaux
 * choix à la place de la question ("Prendre contact" / "Rendez-vous
 * projet"), eux aussi de simples liens.
 */
export function render () {

  const trigger = document.querySelector('[data-modal-open="custom-modal"]')
  const modal = document.getElementById('custom-modal')
  if (!trigger || !modal) return

  const steps = modal.querySelectorAll('[data-modal-step]')

  const reset = () => {
    steps.forEach(step => { step.hidden = step.dataset.modalStep !== 'question' })
  }

  const open = () => {
    modal.hidden = false
    document.body.classList.add('-modal-open')
  }

  const close = () => {
    modal.hidden = true
    document.body.classList.remove('-modal-open')
    reset()
  }

  trigger.addEventListener('click', open)

  modal.querySelectorAll('[data-modal-close]').forEach(el => {
    el.addEventListener('click', close)
  })

  modal.querySelectorAll('[data-modal-reveal]').forEach(btn => {
    btn.addEventListener('click', () => {
      const currentStep = btn.closest('[data-modal-step]')
      const nextStep = modal.querySelector(`[data-modal-step="${btn.dataset.modalReveal}"]`)
      if (currentStep) currentStep.hidden = true
      if (nextStep) nextStep.hidden = false
    })
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) close()
  })

}
